// components
import { ControlledCheckbox, ControlledTextField } from 'components/shared';
import {
  GridCompact12,
  GridCompact6,
  GridContainer
} from 'components/shared/Grid/Grid.components';

// hooks
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'hooks';

export const DutyCodeGeneralFields = () => {
  const { t } = useTranslation('common');
  const { hasActivityPlanningViewAccess } = useSelector(({ grants }) => grants);

  const { control } = useFormContext();
  return (
    <GridContainer mb={2.5}>
      <GridCompact12>
        <ControlledTextField
          control={control}
          variant="outlined"
          label={t('description')}
          name="description"
        />
      </GridCompact12>
      <GridCompact6>
        <ControlledCheckbox
          control={control}
          label={t('dutyCodes.flags.REQUEST_EXCLUDE')}
          name="flags.REQUEST_EXCLUDE"
        />
      </GridCompact6>
      {hasActivityPlanningViewAccess && (
        <GridCompact6>
          <ControlledCheckbox
            control={control}
            label={t('dutyCodes.flags.ROUTE')}
            name="flags.ROUTE"
          />
        </GridCompact6>
      )}
    </GridContainer>
  );
};
